module.exports = __webpack_public_path__ + "static/media/index-qrcode.67a0cd8b.png";